import { faEdit, faEnvelope } from "@fortawesome/free-solid-svg-icons"
import { Field, reduxForm, InjectedFormProps } from "redux-form"
import { User } from "../../../rpcs/dist/UserRPC"
import { IFormField, validate } from "./validation"
import React from "react"
import StyledInputField, {
  IStyledFieldProps,
} from "../../../components/parts/styled-field/styled-input-field"
import { AuthSendButton } from "../../../components/templates/auth/components/auth-send-button"
import { faUser } from "@fortawesome/free-solid-svg-icons/faUser"
import StyledTextareaField from "../../../components/parts/styled-field/styled-textarea-field"

type IProps = InjectedFormProps<{}, IFormField>

const formData: Array<
  IStyledFieldProps<keyof Pick<User, "screenName" | "email" | "description">>
> = [
  {
    name: "screenName",
    title: "ユーザー名",
    icon: faUser,
    type: "text",
    placeholder: "ユーザー名",
    component: StyledInputField,
  },
  {
    name: "email",
    title: "メールアドレス",
    icon: faEnvelope,
    type: "email",
    placeholder: "メールアドレス",
    component: StyledInputField,
  },
  {
    name: "description",
    title: "プロフィール",
    icon: faEdit,
    type: "text",
    placeholder: "プロフィール",
    component: StyledTextareaField,
  },
]

export class FormComponent extends React.Component<IProps> {
  public render() {
    const { handleSubmit, submitting } = this.props
    return (
      <form onSubmit={handleSubmit}>
        {formData.map((data, i) => (
          <Field key={i} {...data} />
        ))}
        <AuthSendButton
          isSending={submitting}
          text={"更新"}
          sendingText={"更新中です"}
          onClick={handleSubmit}
        />
      </form>
    )
  }
}

export const Form = reduxForm({
  form: "UserSettingForm",
  validate,
})(FormComponent)
